module.exports = __webpack_public_path__ + "img/black_and_yellow_smoke.009f3e27.png";